import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { CatToggle } from '@blocks-react/components/Toggle';
import { CatHeading } from '@blocks-react/components/Heading';
export const IncludeDismissedNotifications = ({ includeDismissedNotifications, handleToggleChange, title }) => {
    return (_jsxs(_Fragment, { children: [_jsx(CatToggle, { hideLabel: true, checked: includeDismissedNotifications, onBlToggleChange: handleToggleChange, "aria-label": title, "data-testid": "include-dismissed-notifications" }), _jsx(CatHeading, { variant: "body-sm", children: title })] }));
};
